import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {FileService} from "../../../services/api/file.service";
import {AventuraService} from "../../../services/api/aventura.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";

@Component({
  selector: 'app-dialog-ver-equipos',
  templateUrl: './dialog-ver-equipos.component.html',
  styleUrls: ['./dialog-ver-equipos.component.css']
})
export class DialogVerEquiposComponent implements OnInit {

  loading:boolean=true;

  dataSource:any;

  articulos:any;

  displayedColumns: string[] = [
    'nombre',
    'categoria',
    'marca',
    'modelo',
    'talla',
    'observacion',
    'valoracion'

  ];

  file:any

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  //@ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private fileService: FileService,private aventuraService: AventuraService,@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DialogVerEquiposComponent>) { }

  ngOnInit(): void {
    console.log(this.data.file)
    this.getItineraryEquipos()
  }

  getItineraryEquipos() {
    this.fileService.getItineraryEquipos(this.data.file.idItinerary).subscribe((res:any)=>{
      console.log(res)
      this.file=res.getItinerary

      this.dataSource=new MatTableDataSource(this.file.equipos)
      this.dataSource.paginator=this.paginator

      this.loading=false

    })

  }


  closeDialog() {

    this.dialogRef.close();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }



}
